import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { createGetPersonOrUndefined } from '../../../core/states/offer/offer.selector';
import { map } from 'rxjs/operators';

export const personExistsGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);

  const personId = Number(route.params['personId']);
  return store.select(createGetPersonOrUndefined(personId)).pipe(
    map((person) => {
      if (person) {
        return true;
      }
      return router.parseUrl(`${route.url[0].path}/0`);
    }),
  );
};
